<template>
    <div class="p-col-12">
        <div class="card">
            <page-header :title="isBudgets ? 'dataTable.protocol.budgets-title' : 'dataTable.protocol.title'" :actions="pageActions"/>
            <ancestryline-data-table v-if="loadProtocols" :data-function="dataFunction" :columns="columns" :default-filter="filters" ref="protocollistdatatable"/>
        </div>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import DialogService from "@/business/ModalBusiness";
    import Audit from "@/viewer/user/Audit";
    import ProtocolBusiness from "@/business/ProtocolBusiness";
    import ModalProtocolFilter from "@/viewer/protocol/ModalProtocolFilter";
    import store from "@/store";
    import {LIMITED} from "@/constants/TypeUser";
    import {_getStatusProtocolLabel} from "@/constants/StatusProtocol";

    export default {
        name: "ProtocolList",
        components: {PageHeader, AncestrylineDataTable},

        mounted() {
            if (this.$route.path === '/protocol-list') {
                this.filters.budget = false;
            } else if (this.$route.path === '/budgets-list') {
                this.filters.budget = true;
                this.isBudgets = true;
            }
            this.loadProtocols = true;
        },

        data() {
            return {
                loadProtocols: false,
                isBudgets: false,
                filters: {name: null, code: null, family_name: null, person_id: null, budget: null},
                clientFilterTemp: null,
                dataFunction: ProtocolBusiness.pagination,
            }
        },

        computed: {
            columns() {
                const columns = [
                    {field: "code", header: 'dataTable.protocol.columns.protocol', sortable:true, type: 'actions', customFunction: this.protocolName,
                        actions: [
                            {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
                        ]
                    },
                    {field: "name", header: 'dataTable.protocol.columns.name', sortable:true, type: 'actions',
                        actions: [
                            {type: 'protocolLink', title: 'dataTable.protocol.columns.protocol'},
                        ]
                    },
                    {field: "created", header: 'dataTable.protocol.columns.created', sortable:true, type: 'date-time'},
                    {field: "status", header: 'dataTable.protocol.columns.status', sortable:true, type: 'tag', function: _getStatusProtocolLabel,
                        colors: {
                            ACTIVE: 'p-tag-info',
                            CANCELED: 'p-tag-danger',
                            FINISHED: 'p-tag-success',
                        }
                    },
                    {field: "typeServiceName", header: 'dataTable.protocol.columns.type-service', sortable:true},
                    {field: "mainClientName", header: 'dataTable.protocol.columns.main-client', sortable:true, type: 'actions',
                        actions: [
                            {type: "mainClientLink", title: 'dataTable.client.columns.name'},
                        ]
                    },
                ];
                if (store.getLoggedUser().typeUser !== LIMITED) {
                    columns.push(
                        {
                            field: "actions",
                            header: 'dataTable.actions',
                            sortable: false,
                            type: 'actions',
                            style: 'width: 100px',
                            actions: [
                                {
                                    icon: 'pi pi-pencil',
                                    title: 'dataTable.protocol.columns.edit',
                                    function: this.editProtocol
                                },
                            ]
                        }
                    );
                }
                return columns;
            },

            pageActions() {
                let pageActions = [
                    {icon: 'pi pi-filter', label: 'dataTable.protocol.filters', function: this.openFilterModal, type: 'button'},
                ];
                return pageActions;
            }

        },

        methods: {

            editProtocol(protocol){
                FrontBusiness.redirect(`/protocol/form/${protocol.id}`);
            },

            openModal(){
                DialogService.openModal(Audit, {business: ProtocolBusiness});
            },

            protocolName: ProtocolBusiness.protocolName,

            async openFilterModal(){
              if(this.clientFilterTemp){
                this.$set(this.filters, 'person_id', this.clientFilterTemp);
              }
              const filters = await DialogService.openModal(ModalProtocolFilter, {filters: this.filters});
              if(filters){
                if(filters.person_id instanceof Object){
                  this.clientFilterTemp = filters.person_id;
                  filters.person_id = filters.person_id.id;
                } else {
                  this.clientFilterTemp = null;
                }
                this.$set(this.$refs.protocollistdatatable, 'filters', filters);
                this.$set(this, 'filters', filters);
                await this.$refs.protocollistdatatable.loadPage();
              }
            },

        }

    }
</script>

<style scoped>

</style>
